import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";

import Reveal from "../Reveal/Reveal";

function HeroAction({ action }) {
  const className = `button ${
    action.variant === "secondary" ? "button-secondary" : "button-primary"
  }`;

  if (action.href) {
    return (
      <a
        className={className}
        href={action.href}
        target={action.external ? "_blank" : undefined}
        rel={action.external ? "noreferrer" : undefined}
      >
        {action.label}
        <FiArrowRight aria-hidden="true" />
      </a>
    );
  }

  return (
    <Link className={className} to={action.to}>
      {action.label}
      <FiArrowRight aria-hidden="true" />
    </Link>
  );
}

export default function PageHero({
  eyebrow,
  title,
  description,
  actions = [],
  stats = [],
  media = null,
}) {
  return (
    <section className="page-hero">
      <div className="section-shell page-hero__grid">
        <Reveal className="page-hero__copy">
          {eyebrow ? <p className="section-kicker">{eyebrow}</p> : null}
          <h1 className="page-title">{title}</h1>
          <p className="page-summary">{description}</p>

          {actions.length ? (
            <div className="button-group">
              {actions.map((action) => (
                <HeroAction action={action} key={action.label} />
              ))}
            </div>
          ) : null}

          {stats.length ? (
            <dl className="metric-list">
              {stats.map((stat) => (
                <div className="metric-item" key={stat.label}>
                  <dt>{stat.label}</dt>
                  <dd>{stat.value}</dd>
                </div>
              ))}
            </dl>
          ) : null}
        </Reveal>

        {media ? <Reveal className="page-hero__media" delay={120}>{media}</Reveal> : null}
      </div>
    </section>
  );
}
